import React from "react";
import "./blog.css";
import logo from "./Dev.png";
import medium from "./Medium.png";
import external from "./ExternalL.png";
const BlogDump = () => {
  return (
    <div className="wrap">
      <div className="header">
        Blog Dump.
        <p>
          Talking about my interests and giving 2 cents on the tech news I read
        </p>
      </div>

      <div className="devb">
        <a
          href="https://dev.to/aishanipach/wwdc-keynote-facetimed-us"
          target="_blank"
          className="encloser"
        >
          <img
            className="column"
            src="https://res.cloudinary.com/practicaldev/image/fetch/s--qTAfXgfm--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/25kltu1ws1oqunwyuk7n.jpg"
          ></img>
          <div className="namedev">
            <div className="text">WWDC Keynote Facetimed us</div>
          </div>
        </a>

        <a
          href="https://dev.to/aishanipach"
          target="_blank"
          className="column1"
        >
          <img className="more" src={logo}></img>
        </a>
      </div>

      <div className="mediumb">
        <div className="blog1">
          <a
            className="heading"
            href="https://medium.com/acm-juit/how-to-get-started-arfoundation-in-unity-f0a050b3585f"
            target="_blank"
          >
            How to get started: ARFoundation in Unity
            <img className="external" src={external}></img>
          </a>
          <p className="content">
            When getting started with augmented reality apps in Unity there are
            two types of AR apps that you can develop: marker- based and marker
            less.<br></br> Today, we are talking about markerless AR and using
            ARFoundation for the same...
          </p>
        </div>

        <div className="blog1">
          <a
            target="_blank"
            className="heading"
            href="https://medium.com/acm-juit/how-to-get-started-arfoundation-in-unity-f0a050b3585f"
          >
            Hacking into Marketing
            <img className="external" src={external}></img>
          </a>
          <p className="content">
            So, I recently came across a startup where the idea was to deploy a
            deep learning model to synthesize suitable content for their
            audience which<br></br> in turn led to a discussion on “Marketing
            Algorithms” that made me wonder about the degree to which such
            automation can be done...
          </p>
        </div>

        <div className="blog1">
          <a
            target="_blank"
            className="heading"
            href="https://medium.com/acm-juit/how-to-get-started-arfoundation-in-unity-f0a050b3585f"
          >
            Miracles of Marketing
            <img className="external" src={external}></img>
          </a>
          <p className="content">
            Today, marketing is not just taking action to promote a product or a
            service. It is much more than that and what is its impact? you may
            ask.<br></br>Much bigger than what you think. Marketing is pursuing
            customers and retaining them. To influence them, we need to
            understand human behaviour…
          </p>
        </div>
      </div>
    </div>
  );
};

export default BlogDump;
